import firebase from 'firebase';

var config = {
    apiKey: "AIzaSyCEx9kb4C2miZ3XgcBT4ckC-38-Lrjnl60",
    authDomain: "printplatechat.firebaseapp.com",
    databaseURL: "https://printplatechat.firebaseio.com",
    projectId: "printplatechat",
    storageBucket: "printplatechat.appspot.com",
    messagingSenderId: "553547108091",
    appId: "1:553547108091:web:fd44f2f1d193b9f70a2a5e"
};
var firebaseApp = firebase.initializeApp(config);

export default firebaseApp;